/* specifically target IE11 */
/* controlled focus outline */
/**
 * AGL BRAND TOKENS VERSION 0.2.45
 * GENERATED BY STYLE DICTIONARY
 * DO NOT EDIT THIS FILE DIRECTLY
 */
/* usage
.selector {
  color: red;

  @include breakpoint(sm) {
    color: blue;
  }
}
*/
:host {
  display: inline;
}

/* this needs to be a global class rather than a mixin/variable so it can be dynamically added to dom elements */
.sr-only {
  position: absolute !important;
  clip: rect(0, 0, 0, 0);
  margin: -1px;
  padding: 0 !important;
  border: 0 !important;
  height: 1px !important;
  width: 1px !important;
  overflow: hidden;
}

.dls-icon-dynamic__size--sm {
  height: 24px;
  width: 24px;
}
.dls-icon-dynamic__size--sm svg {
  height: 24px;
  width: 24px;
}
.dls-icon-dynamic__size--md {
  height: 32px;
  width: 32px;
}
.dls-icon-dynamic__size--md svg {
  height: 32px;
  width: 32px;
}
.dls-icon-dynamic__size--lg {
  height: 48px;
  width: 48px;
}
.dls-icon-dynamic__size--lg svg {
  height: 48px;
  width: 48px;
}
.dls-icon-dynamic__size--xl {
  height: 64px;
  width: 64px;
}
.dls-icon-dynamic__size--xl svg {
  height: 64px;
  width: 64px;
}